export const googleRating = {
  score: "5.0",
  total: "1,300+",
  profileUrl: "https://maps.app.goo.gl/Fbcy2wkkirJXD3eN8",
};

export const googleReviews = [
  {
    name: "sheetal nayaka",
    meta: "4 reviews",
    timeAgo: "3 weeks ago",
    rating: 5,
    isNew: true,
    avatarType: "photo",
    image:
      "/uploads/reviewer-sheetal.jpeg",
    initial: "",
    avatarColor: "#5f6368",
    quote:
      "Had a very good experience with Lahari Packers and Movers for our house shifting. The entire team was professional, punctual, and handled all our belongings with great care. Packing was done neatly, and the shifting process was smooth and hassle-free.\n\nReally appreciate the team for their hard work, coordination, and careful handling of everything. Highly recommended for anyone looking for a reliable and professional moving service! 👍",
  },
  {
    name: "Raju Shivaram",
    meta: "1 review · 1 photo",
    timeAgo: "a month ago",
    rating: 5,
    isNew: false,
    avatarType: "photo",
    image:
      "/uploads/reviewer-raju.jpeg",
    initial: "",
    avatarColor: "#1a73e8",
    quote:
      "Excellent services, they shifted the entire items to my new home. The staffs are also cooperative and worth the money",
  },
  {
    name: "Chinnigowda",
    meta: "2 reviews",
    timeAgo: "4 months ago",
    rating: 5,
    isNew: false,
    avatarType: "initial",
    image: "",
    initial: "C",
    avatarColor: "#5f6368",
    quote:
      "I would like to express my sincere appreciation for the outstanding service provided by Lahari Packers and Movers. The entire relocation process was managed with exceptional professionalism, efficiency, and care from start to finish.\n\nThe team demonstrated excellent coordination, punctuality, and dedication throughout the packing and moving process. Every item was handled carefully and delivered safely without any inconvenience or damage. Their organized approach and commitment to customer satisfaction truly made the shifting experience smooth and stress-free.\n\nI am highly impressed with their quality of service, transparent communication, and responsible staff members. I would confidently recommend Lahari Packers and Movers to anyone seeking dependable, secure, and professional relocation services.\n\nThank you for delivering such a reliable and hassle-free experience.",
  },
  {
    name: "Nishanth S",
    meta: "6 reviews",
    timeAgo: "2 months ago",
    rating: 5,
    isNew: false,
    avatarType: "initial",
    image: "",
    initial: "N",
    avatarColor: "#e91e63",
    quote:
      "Very good service by Lahari packers and movers — the team was punctual, professional, and handled everything with care. The packing was neat, the shifting was smooth, and all my belongings arrived safely without any damage. Really appreciate their efficient work and would definitely recommend them to anyone looking for a hassle-free moving experience.",
  },
  {
    name: "Manigandan B",
    meta: "6 reviews",
    timeAgo: "a month ago",
    rating: 5,
    isNew: false,
    avatarType: "initial",
    image: "",
    initial: "M",
    avatarColor: "#f4511e",
    quote:
      "Excellent service from the Packers and Movers team! They arrived exactly on time and handled everything in a very professional manner. The packing was neat, secure, and carefully done without any damage. The staff were cooperative, polite, and very efficient throughout the shifting process. Overall, a smooth and hassle-free moving experience—highly recommended!",
  },
];